import OutOfStockCart from './out-of-stock-cart'

export default OutOfStockCart
